import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.devices')
  .factory('$devices', devicesObjectFactory);

/* @ngInject */
function devicesObjectFactory($bringozFactory: $bringozFactory,
                              DevicesAPI: BringozApi,
                              Devices_DS: DataStoreConfig,
                              Devices_PN: PushNotificationsConfig) {

  function $devices(id: string) {
    return $bringozFactory(id, DevicesAPI, Devices_DS, Devices_PN);
  }
  return $devices;
}
